import { PRP_FLOW_V1 } from './constants';

export function capitalize(word) {
  return word.charAt(0).toUpperCase() + word.slice(1);
}

export const capitalizeOnlyFirst = (word = '') => {
  if ((word || '').trim() !== '') {
    return `${word.charAt(0).toUpperCase()}${word.slice(1).toLowerCase()}`;
  } else {
    return '';
  }
};

function checkAndLogNonSentryObj(errorMessage = '') {
  if (!window.Sentry) {
    const msgAux = errorMessage ? ' Raised error: ' + errorMessage : '';
    const msg = 'Error handling exception with Sentry, please check the conditions in the sentry_js.html file.' + msgAux;
    console.log(msg);
  }
}

export function processInfo(storeObj = null, msg = '', showAlert = false, errorObj = undefined, doNotSendToSentry = false) {
  if (showAlert) alert(msg);
  msg += `${msg ? '. ' : ''}${getErrorStr(errorObj)}`;
  if (!doNotSendToSentry) {
    try {
      if (storeObj) window.Sentry.setContext('vue store', { store: storeObj });
      window.Sentry.captureMessage(msg, 'info');
    } catch (error) {
      const errorMessage = error.message || `Error in processInfo function. ${error}`;
      checkAndLogNonSentryObj(errorMessage);
      throw Error(errorMessage);
    }
  }
}

export function processError(storeObj = null, msg = '', showAlert = false, errorObj = undefined, doNotSendToSentry = false) {
  if (showAlert) alert(msg);
  msg += `${msg ? '. ' : ''}${getErrorStr(errorObj)}`;
  if (!doNotSendToSentry) {
    try {
      if (storeObj) window.Sentry.setContext('vue store', { store: storeObj });
      window.Sentry.captureException(msg);
    } catch (error) {
      const errorMessage = error.message || `Error in processError function. ${error}`;
      checkAndLogNonSentryObj(errorMessage);
      throw Error(errorMessage);
    }
  }
}

export function getErrorStr(errorObj) {
  if (!errorObj) {
    return '';
  }
  let errorStr = '';
  if (errorObj.responseJSON) {
    if (errorObj.responseJSON.non_field_errors &&
        errorObj.responseJSON.non_field_errors.length > 0) {
      errorStr = errorObj.responseJSON.non_field_errors[0];
    } else {
      if (typeof errorObj.responseJSON === 'string') {
        errorStr = errorObj.responseJSON;
      } else {
        errorStr = errorObj.responseJSON[0];
      }
    }
  } else if (errorObj.responseText) {
    errorStr = errorObj.responseText;
  } else if (typeof errorObj === 'string' && errorObj) {
    errorStr = errorObj;
  } else if (typeof errorObj === 'object' && errorObj.message) {
    errorStr = errorObj.message;
  } else {
    try {
      errorStr = JSON.stringify(errorObj, null, 2);
    } catch (e) {
      /* When using JSON.stringify() with JavaScript errors, specifically, objects inheriting from the Error class,
      the output is an empty object. JSON.stringify() only includes enumerable properties and the Error class
      doesn’t have any. */
      errorStr = String(errorObj);
    }
  }

  if (errorObj.status) {
    errorStr += !errorObj.status ? '' : ` [${errorObj.status}]`;
  }

  return errorStr;
}

export function formatQuestionTextInParenthesis(text) {
  let retVal = text;
  if (text.includes('? (') && text.includes(')')) {
    const idx = text.indexOf('? (')
    let firstText = text.substring(0, idx + 2);
    let lastText = text.substring(idx + 2);
    if (firstText && lastText) {
      firstText = firstText.replace(firstText, `<p>${firstText.trim()}</p>`);
      lastText = lastText.replace(lastText, `<p class="small black">${lastText.trim()}</p>`);
      retVal = `${firstText}${lastText}`;
    }
  }
  return retVal;
}

export function formatTextFirstBold(text, identifier, firstClass = 'p-bold', secondClass = 'p-small') {
  let retVal = text;
  if (text.includes(identifier)) {
    const idx = text.indexOf(identifier);
    if (idx >= 0) {
      let firstText = text.substring(0, idx + 1);
      let lastText = text.substring(idx + 1);
      if (firstText && lastText) {
        firstText = firstText.replace(firstText, `<span class="${firstClass}">${firstText.trim()}</span>`);
        lastText = lastText.replace(lastText, `<p class="${secondClass}">${lastText.trim()}</p>`);
        retVal = `<span>${firstText}${lastText}</span>`;
      }
    }
  }
  return retVal;
}

export function formatAnswerTextInParenthesis(text, className, classNameParenthesis) {
  let retVal = text;
  if (text.includes('(') && text.includes(')')) {
    const pClass = classNameParenthesis ? ' class=' + classNameParenthesis : '';
    retVal = text.replace('(', `&nbsp;<p${pClass}>(`).replace(')', ')</p>');
    retVal = `<span class=${className || 'option-nowrap'}>${retVal}</span>`;
  }
  return retVal + '<em class="fa fa-check"></em>';
}

export function getPrpFlowVersion() {
  try {
    return window.sessionStorage.getItem('prpFlowVersion') || '';
  } catch (error) {
    return PRP_FLOW_V1;
  }
}

export function isExceptionWithResponseJSONArray(errorObj) {
  if (!errorObj) return false;
  return Array.isArray(errorObj.responseJSON) && errorObj.responseJSON.length > 0
}
